export const createScoresheetSchemasRequests = (client) => ({
    listScoresheetSchemas: async (params) => {
        const { data, meta, links } = await client.api.get("scoresheet_schemas", {
            params: params,
        });
        return { data, meta, links };
    },
    findScoresheetSchema: async (params) => {
        const { data } = await client.api.get(`scoresheet_schemas/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    createScoresheetSchema: async (payload) => {
        const { data } = await client.api.create("scoresheet_schemas", payload);
        return { data };
    },
    updateScoresheetSchema: async (payload) => {
        const { data } = await client.api.update("scoresheet_schemas", payload);
        return { data };
    },
});
//# sourceMappingURL=index.js.map